import { render } from "./About.vue?vue&type=template&id=fe66e5fe&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=fe66e5fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fe66e5fe"

export default script